import React, { memo, useCallback, useEffect, useState } from "react";
import { uploadFileToS3 } from "../../helper/utils";
import { useFetch } from "../../hooks/useFetch";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import _ from "lodash";
import DynamicButton from "../../component/button";
import BottomSheet from "./sheet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AToggleLoding } from "../../store/reducer/settings";
import CustomModal from "../../component/modal/CustomModal";
import { toast } from "react-toastify";

function UploadEmirateID() {
  const router = useNavigate();
  const dispatch = useDispatch();
  const [query] = useSearchParams();
  const [loader, setLoader] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<any>([]);
  const state = useSelector((state: RootState) => state.invitation.invitation);
  const [open, setOpen] = useState<boolean>(false);
  const [token, setToken] = useState<string>("");
  const [mounted, setMounted] = useState<boolean>(false);
  const [Tokenresponse, Setresponse] = useState<any>({});
  const [CompantPlatform, setCompantPlatform] = useState<any>([]);
  const [popInfoPopup, setpopInfoPopup] = useState<any>(false);
  const [side, setside] = useState<any>("");
  const [uploadError, setUploadError] = useState<string | null>(null); // New state for duplicate error

  useEffect(() => {
    if (!mounted) setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (mounted) {
      const token = query.get("token");
      if (token) setToken(token);
      else router("/invalid");
    }
  }, [mounted]);

  const uploadImage = async (filee: any, item: any) => {
    if (filee) {
      // Check for duplicate file
      const isDuplicate = CompantPlatform.some((v: any) => {
        return (
          v.fileMeta &&
          v.fileMeta.name === filee.name &&
          v.fileMeta.size === filee.size
        );
      });

      if (isDuplicate) {
        toast.error("You have already uploaded this file.");
        return;
      }

      dispatch(AToggleLoding());
      const { type: fileType, name: fileName } = filee;
      const type = fileName.split(".").pop();

      const { data }: any = await useFetch.get("medias/b2c-signed-url", {
        params: {
          requestType: "upload",
          b2cReqId: Tokenresponse.b2cReqId,
          cnic: Tokenresponse.cnic,
          scope: "any",
          fileName: `${Tokenresponse.cnic}.${type}`,
          fileType,
          folderName: "b2c",
          key: state?.key,
        },
      });

      const url = data?.data?.signedUrl;
      await uploadFileToS3(url, filee);
      const urlPath = data?.data?.urlPath;
      const updatedfiles = await readFileObject(filee);

      const updatedData = CompantPlatform.map((v: any) => {
        if (v.index === item.index) {
          return {
            ...v,
            mediaproof: urlPath,
            previewfile: updatedfiles,
            fileMeta: filee, // Store original file
          };
        }
        return v;
      });

      dispatch(AToggleLoding());
      setCompantPlatform(updatedData);
      setOpen(true);
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(AToggleLoding());
      useFetch
        .post("b2c/fetch-token", {
          token,
        })
        .then((res) => {
          const { data } = res;
          Setresponse(data.data || {});
          dispatch(AToggleLoding());
        })
        .catch(() => {
          dispatch(AToggleLoding());
          return router("/invalid");
        });
    }
  }, [token]);

  useEffect(() => {
    if (Tokenresponse) {
      setCompantPlatform([
        {
          index: 0,
          mediaproof: "",
          previewfile: "",
          side: "Front",
          fileMeta: null,
        },
        {
          index: 1,
          mediaproof: "",
          previewfile: "",
          side: "Back",
          fileMeta: null,
        },
      ]);
    }
  }, [Tokenresponse]);

  const readFileObject = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  const handleNext = () => {
    setLoader(true);
    const updatedFileData = CompantPlatform.map((item: any) => {
      return {
        mediaProof: item.mediaproof,
      };
    });

    let body = {
      id: Tokenresponse.b2cReqId,
      companyName: Tokenresponse.companies.join(", "),
      step: 1,
      info: {
        cnic: updatedFileData,
      },
    };

    return useFetch
      .post(`b2c/request/step`, {
        ...body,
      })
      .then((res: any) => {
        setLoader(false);
        router("?status=completed");
        return res?.data?.data?.id;
      })
      .catch((err) => {
        setLoader(false);
        console.log("ERROR", err?.response?.data);
        throw err;
      });
  };

  const validateData = (data: any) => {
    return data.some((item: any) => !item.mediaproof || item.mediaproof === "");
  };

  const ondelteImage = (index: any) => {
    const updatedData = CompantPlatform.map((item: any, i: number) => {
      if (i === index) {
        return {
          ...item,
          mediaproof: "",
          previewfile: "",
          fileMeta: null,
        };
      }
      return item;
    });
    setCompantPlatform(updatedData);
  };

  const handleInfoPopUp = (side: any) => {
    setside(side);
    setpopInfoPopup(!popInfoPopup);
  };

  return (
    <>
      {popInfoPopup &&
        (side === "Front" ? (
          <CustomModal
            image={"/assets/FrontCnic.png"}
            paragraph={
              "Use your camera to capture a clear photo of the front side of your Emirates ID or Upload a photo of your Emirates ID from your phone's gallery."
            }
            onClose={() => setpopInfoPopup(!popInfoPopup)}
          />
        ) : (
          <CustomModal
            image={"/assets/BackCnic.png"}
            paragraph={
              "Use your camera to capture a clear photo of the back side of your Emirates ID or Upload a photo of your Emirates ID from your phone's gallery."
            }
            onClose={() => setpopInfoPopup(!popInfoPopup)}
          />
        ))}

      <div className="flex flex-col p-5 pt-10 justify-between h-[100vh] w-full overflow-x-hidden">
        <div>
          <div className="flex flex-col w-full items-center justify-center">
            <img src="/assets/uploadIcon.svg" alt="upload" />
            <h1 className="text-white text-center font-bold text-xl mt-3">
              Upload Emirate ID
            </h1>
            <p className="text-center text-white text-[14px] mt-4">
              Please Upload your Emirates ID for verification
            </p>
          </div>

          {CompantPlatform.map((item: any, key: number) => (
            <div key={key}>
              <div className="mt-6 flex-row flex items-center">
                <h2 className="text-white text-[12px]">
                  Upload {item.side} side
                </h2>
                <button onClick={() => handleInfoPopUp(item.side)}>
                  <img
                    src="/assets/InfoIcon.png"
                    className="ml-2"
                    height={20}
                    width={20}
                    alt=""
                  />
                </button>
              </div>

              <input
                type="file"
                className="hidden"
                id={`file${key + 1}`}
                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                onChange={(e: any) => uploadImage(e?.target?.files[0], item)}
              />

              <div className="relative w-[100%]">
                {item?.previewfile ? (
                  <button
                    onClick={() => ondelteImage(key)}
                    className="h-5 w-5 absolute bg-white rounded-xl flex items-center justify-center -top-2 -right-2"
                  >
                    <h1>X</h1>
                  </button>
                ) : null}
                <label htmlFor={`file${key + 1}`}>
                  <div
                    className={`flex mt-4 p-2 ${
                      item?.previewfile == "" ? "h-[100px]" : "h-[200px]"
                    } w-[100%] rounded-[5px] border-2 border-[#2B486B] border-dashed items-center overflow-hidden`}
                  >
                    {item?.previewfile == "" ? (
                      <div className="justify-between items-center flex flex-row w-[100%] px-5">
                        <h1 className="text-white text-[12px]">
                          Emirates ID Card.jpeg
                        </h1>
                        <div className="h-[35px] w-[35px] border-white border-2 rounded-full items-center justify-center flex flex-row">
                          <h1 className="text-white text-[30px]">+</h1>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={item?.previewfile}
                        className="w-[100%] h-[100%]"
                        alt="img"
                      />
                    )}
                  </div>
                </label>
              </div>
            </div>
          ))}
        </div>

        <div className="flex mt-10 w-full items-start justify-center">
          <DynamicButton
            isDisabled={validateData(CompantPlatform)}
            type="submit"
            isLoading={loader}
            onClick={handleNext}
          >
            NEXT
          </DynamicButton>
        </div>
      </div>
    </>
  );
}

export default memo(UploadEmirateID);
